import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { Configuration, ITEM_NAMES } from "product-test-types";

import { TestAppState } from "../app";

type ItemName = Exclude<Configuration["itemName"], undefined>;

export function getItemName(itemNAme?: ItemName, language = "en") {
  if (!itemNAme) {
    return getLocalizedMessage(language, "trackingItem") || "Tracking Item";
  }

  const found = ITEM_NAMES.find(({ single }) => single === itemNAme);

  return (
    getLocalizedMessage(language, `itemNames.${found?.single}`) ||
    getLocalizedMessage(language, "trackingItem") ||
    "Tracking Item"
  );
}

export function getItemNameFromState(appState: TestAppState) {
  const language = appState.language || "en";
  const itemName = appState.settings?.configuration?.itemName;

  return getItemName(itemName, language);
}

export function getPluralOfItemName(itemName?: ItemName, language = "en") {
  if (!itemName) {
    return getLocalizedMessage(language, "trackingItems") || "Tracking Items";
  }

  const found = ITEM_NAMES.find(({ single }) => single === itemName);

  return (
    getLocalizedMessage(language, `itemNames.${found?.plural}`) ||
    getLocalizedMessage(language, "trackingItems") ||
    "Tracking Items"
  );
}

export function getPluralOfItemNameFromState(appState: TestAppState) {
  const language = appState.language || "en";
  const itemName = appState.settings?.configuration?.itemName;

  return getPluralOfItemName(itemName, language);
}
